<nav class="navbar navbar-light bg-white shadow-sm">
  <a class="navbar-brand" [routerLink]="['/']">
    <img src="../../../../../assets/images/logo_rnt.png" height="32" class="d-inline-block align-top" alt="">
    Registro Nacional de Turismo
  </a>
  <div class="navbar-expand">
    <div class="navbar-nav m-auto">
      <a class="nav-item nav-link ml-2" routerLinkActive="active" [routerLink]="['/faq']">
        <span>FAQ</span>
      </a>
      <a class="nav-item nav-link ml-2" routerLinkActive="active" [routerLink]="['/legislacion']">
        <span>Legislación</span>
      </a>
      <a class="nav-item nav-link ml-2" routerLinkActive="active" [routerLink]="['/videosTutoriales']">
        <span>Vídeo tutoriales</span>
      </a>
      <a class="nav-item nav-link ml-2 mr-5" routerLinkActive="active" [routerLink]="['/terminos']">
        <span>Términos y condiciones</span>
      </a>
      <a class="nav-item nav-link btn-back ml-5" *ngIf="!userLogin" [routerLink]="['/home']">
        <span class="pl-4 pr-4">Regresar</span>
      </a>
      <a class="nav-item nav-link btn-back ml-5 pointer" *ngIf="userLogin" (click)="onRegresar()">
        <span class="pl-4 pr-4">Regresar</span>
      </a>
    </div>
  </div>
</nav>
<ng-content></ng-content>
<nav class="navbar navbar-light bg-white shadow-sm footer border-top">
  <footer class="col-sm-12 text-center">
    <address class="m-0 small mr-2">
      <a class="text-muted ol pointer" (click)="onOLClick()">&copy; Confec&aacute;maras</a>
       | Red de c&aacute;maras de comercio - {{year|date:'y'}}
    </address>
  </footer>
</nav>
